import { transformDataTestIds } from '@backoffice-frontend/common'
import { FleetManagementTestingAreaId } from './FleetManagementTestingAreaId'

export const FleetManagementTestingAreaDataTestIds = transformDataTestIds({
  Base: FleetManagementTestingAreaId,
  Navigation: 'navigation',
  Card: {
    Base: 'card',
    Error: 'error',
  },
})
